const account_center = {
    not_enabled: 'Account center is not enabled.',
    filed_not_editable: 'Field is not editable.',
};
export default Object.freeze(account_center);
